export const OTHER_REGION = 'outros';
export const ALREADY_VISITED_STORAGE_KEY = 'already-visited';
export const ALREADY_VISITED_OTHER_REGION_STORAGE_KEY =
  'already-visited-other-region';
